<template>
  <nav
    class="fixed bottom-0 left-0 right-0 z-50 bg-white/95 dark:bg-gray-900/95 backdrop-blur-md border-t border-gray-200 dark:border-gray-700 shadow-[0_-4px_20px_rgba(0,0,0,0.06)] pb-[env(safe-area-inset-bottom,0px)]"
    :aria-label="t('portalNav.menu')"
  >
    <div class="flex justify-around items-stretch max-w-lg mx-auto min-h-[3.75rem]">
      <RouterLink
        v-for="item in navigationItems"
        :key="item.to"
        :to="item.to"
        :class="[
          'flex flex-col items-center justify-center flex-1 gap-1 py-2 px-1 text-[11px] sm:text-xs font-medium transition-colors active:scale-[0.98] touch-manipulation',
          navActive(item.to)
            ? 'text-primary-600 dark:text-primary-400'
            : 'text-gray-500 dark:text-gray-400'
        ]"
      >
        <i :class="[item.icon, 'text-xl sm:text-[1.35rem]']" aria-hidden="true" />
        <span class="leading-tight text-center line-clamp-2">{{ item.label }}</span>
      </RouterLink>
    </div>
  </nav>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
import { computed } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()

/** Çalışan portalı: tüm öğeler her zaman görünür (yetki karmaşası yok) */
const navigationItems = computed(() => [
  { label: t('portalNav.payroll'), to: '/portal/payrolls', icon: 'pi pi-wallet' },
  { label: t('portalNav.home'), to: '/portal', icon: 'pi pi-home' },
  { label: t('portalNav.requests'), to: '/portal/requests', icon: 'pi pi-inbox' },
  { label: t('portalNav.ppeShort'), to: '/portal/procurement-requests', icon: 'pi pi-shopping-cart' },
  { label: t('portalNav.leaveShort'), to: '/portal/leave-balance', icon: 'pi pi-calendar' },
  { label: t('portalNav.documentShort'), to: '/portal/documents', icon: 'pi pi-file' }
])

function navActive(to: string) {
  const p = route.path
  if (to === '/portal') return p === '/portal' || p === '/portal/'
  return p === to || p.startsWith(to + '/')
}
</script>
